import { render, staticRenderFns } from "./CaretUpIcon.vue?vue&type=template&id=1d08b107&"
import script from "./CaretUpIcon.vue?vue&type=script&lang=js&"
export * from "./CaretUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports